import { render, staticRenderFns } from "./GestionLimpieza.vue?vue&type=template&id=5dff2d4c"
import script from "./GestionLimpieza.vue?vue&type=script&lang=js"
export * from "./GestionLimpieza.vue?vue&type=script&lang=js"
import style0 from "./GestionLimpieza.vue?vue&type=style&index=0&id=5dff2d4c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports